module.exports = __webpack_public_path__ + "assets/img/00030.47479831.png";